import { api } from '@/shared/api/api';
import { Button, Form, Input, message, Modal } from 'antd';
import { useState } from 'react';

const GenerateNewSerialModal = ({ fetchData }) => {
  const [form] = Form.useForm();
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(prev => !prev);

  const handleCancel = () => {
    form.resetFields();
    setShowModal(false);
  };

  const onFinish = async values => {
    try {
      const { data: resSerialData } = await api.post(`/api/serial/create-serial`, {
        serial: values.serial,
        deviceCount: values.deviceCount,
      });

      if (!resSerialData.error) {
        message.success('Серия успешно добавлено!');
      } else {
        message.error('Не удалось добавить серию!');
      }

      fetchData();
      handleCancel();
    } catch (error) {
      console.error('ERROR - onGenerateNewSerialModal - forwarder>>>', error);
    }
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(values => {
        form.resetFields();
        onFinish(values);
      })
      .catch(info => {
        console.info('Validate failed: ', info);
      });
  };

  return (
    <>
      <Button type='primary' onClick={toggleModal}>
        Сгенерировать серию
      </Button>
      <Modal
        title='Добавление новой серии'
        open={showModal}
        onCancel={handleCancel}
        footer={[
          <Button key='back' onClick={handleCancel}>
            Отмена
          </Button>,
          <Button key='submit' type='primary' onClick={handleOk}>
            OK
          </Button>,
        ]}
      >
        <Form
          name='basic'
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          form={form}
          autoComplete='off'
        >
          <Form.Item
            label='Название серии'
            name='serial'
            rules={[{ required: true, message: 'Необходимо указать название серии!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label='Количество устройств в рамках серии'
            name='deviceCount'
            rules={[{ required: true, message: 'Необходимо указать количество устройств серии!' }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default GenerateNewSerialModal;
